import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import { UserContext } from "../../components/context/userContext";
import SideBarAdmin from "../../components/SideBarAdmin";
import Modal from "react-modal";

import NavBar from "../../components/Navbarr";
import { Formik } from "formik";
import Footerr from "../../components/Footerr";
import AccessDenied from "../../components/AccessDenied";
import { getPackages } from "../../services/get-all-packages";
import ModalPackage from "../../components/ModalPackage";
import ModalAddPackagePhoto from "../../components/ModalAddPackagePhoto";
import ModalAssociatedProds from "../../components/ModalAssociatedProds";
import addPackageWithPhoto from "../../services/post-package-with-photo";
import { addAssociatedProducts } from "../../services/post-associated-products";
import { updateAssociatedProducts } from "../../services/update-associated-products";
import updatePackage from "../../services/put-package";
import { api } from "../../config/baseApi";
import Lottie from "react-lottie";
import {
  defaultOptionsLoading,
  defaultloadImage,
} from "../../assets/lottie-animations/animationOptions";
import { deletePackage } from "../../services/delete-package";
import ModalViderBasket from "../../components/ModalViderBasket";

interface initialImageStateType {
  selectedImage: Blob | MediaSource;
  imageUrl: string;
}

const initialImageState: initialImageStateType = {
  selectedImage: null,
  imageUrl: null,
};
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    borderWidth: 0,
    borderRadius: 12,

    background: "transparent",
  },
};

const customStylesDelete = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "50vh",
    // minHeight: "100vh",
    borderWidth: 0.2,
    borderRadius: 12,
    zIndex: 9,

    background: "#fff",
  },
};
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

interface ProductsValue {
  name: string;
  description: string;
  quantity: number;
  sold: number;
  price: number;
  subCategory: string;
}
function Packages() {
  const { user } = useContext(UserContext);
  const { height, width } = useWindowDimensions();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState("first");
  const [listPackages, setListPackages] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState<any>();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [prodToDelete, setProdToDelete] = useState<any>(null);
  const { networkError, setNetworkError } = useContext(UserContext);
  const [loadingSave, setLoadingSave] = useState(false);

  const [images, setImages] = useState<any>([
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
    { ...initialImageState },
  ]);
  const [editMode, setEditMode] = useState(false);

  const [productsValues, setProductsValues] = useState<any>({
    name: "",
    description: "",
    quantity: 0,
    sold: 0,
    price: 0,
    subCategory: null,
  });
  const doGetAllPackages = () => {
    setLoading(true);
    getPackages()
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response.success) {
          setListPackages(response?.content);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  function openModal() {
    setEditMode(false);
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
    setProductsValues({
      name: "",
      description: "",
      quantity: 0,
      sold: 0,
      price: 0,
      subCategory: null,
    });
    setStep("first");
  }
  const closeDeleteModal = () => {
    setIsOpenDelete(false);
  };

  const openDelete = (id: any) => {
    setProdToDelete(id);
    setIsOpenDelete(true);
  };
  const productIds = selectedOption?.map((item) => item.value);

  const SubmitPackage = () => {
    setLoadingSave(true);
    if (editMode) {
      doUpdatePackageWithPhoto(productsValues._id);
    } else {
      doAddPackageWithPhoto();
    }
  };

  const doAddAsociatedProduct = (packageId, productsIds) => {
    const data = {
      packageId: packageId,
      productIds: productsIds,
    };
    addAssociatedProducts(data)
      .then((response) => {
        setLoadingSave(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response?.success) {
          toast.success("package and associated products added successfuly");
          closeModal();
        }
      })
      .catch((error) => {
        setLoadingSave(false);

        toast.error(error);
      });
  };
  const doUpdateAsociatedProduct = (packageId, productsIds) => {
    const data = {
      packageId: packageId,
      productIds: productsIds,
    };
    updateAssociatedProducts(data, packageId)
      .then((response) => {
        setLoadingSave(false);

        if (response?.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response?.success) {
          toast.success("package and associated products added successfuly");
          window.location.reload();
          closeModal();
        }
      })
      .catch((error) => {
        setLoadingSave(false);

        toast.error(error);
      });
  };

  const doAddPackageWithPhoto = () => {
    const data = { ...productsValues };
    data.photo = selectedImage;

    addPackageWithPhoto(data)
      .then((response: any) => {
        if (response?.data.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.data.success) {
          toast.error(response?.data?.message);
          return;
        }
        if (response?.data.success) {
          closeModal();
          doAddAsociatedProduct(response?.data?.content?._id, productIds);
        }
      })
      .catch((error) => {
        setLoadingSave(false);

        toast.error(error);
      });
  };
  const handleDelete = async () => {
    const token = await localStorage.getItem("token");
    deletePackage(prodToDelete, token)
      .then((response) => {
        if (response.status === 500) {
          toast.error("internal server error");
          return;
        }
        if (!response.success) {
          toast.error(response.message);
          return;
        }
        if (response.success) {
          closeDeleteModal();
          toast.success("Package deleted successfuly !");
          doGetAllPackages();
        }
      })
      .catch((error) => {
        toast.error("error", error);
      });
  };

  const doUpdatePackageWithPhoto = (packageId: any) => {
    const data = { ...productsValues };
    data.photo = selectedImage;

    updatePackage(packageId, data)
      .then((response: any) => {
        if (response?.data.status === 500) {
          setNetworkError(true);
          return;
        }
        if (!response?.data.success) {
          toast.error(response?.data?.message);
          return;
        }
        if (response?.data.success) {
          closeModal();

          doUpdateAsociatedProduct(productsValues?._id, productIds);
        }
      })
      .catch((error) => {
        setLoadingSave(false);

        toast.error(error);
      });
  };

  useEffect(() => {
    doGetAllPackages();
  }, []);

  const openEditMode = (prod) => {
    setProductsValues(prod);
    setEditMode(true);
    setIsOpen(true);
  };

  useEffect(() => {}, []);
  return (
    <>
      {user?.role === 1 ? (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"packages"} />
            </div>
            <div className="body-container">
              <div className="header-body">
                <div className="wrapper">
                  <h3>Packages</h3>
                  <button
                    className="add-categorie-btn"
                    onClick={() => openModal()}
                  >
                    Ajouter <i className="bx bx-plus"></i>
                  </button>
                </div>
                <Formik
                  initialValues={{
                    query: "",
                  }}
                  validate={(values) => {
                    const errors: any = {};
                    if (!values.query) {
                      errors.query = "Required";
                    }
                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      setSubmitting(false);
                    }, 400);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form className="search-form" onSubmit={handleSubmit}>
                      <div className="search-bar-container">
                        <input
                          value={values.query}
                          className="search-bar"
                          onChange={(e) => {
                            handleChange(e);
                            setSearchQuery(e.target.value);
                          }}
                          onBlur={handleBlur}
                          name="query"
                          type="text"
                          placeholder="Search packages..."
                        />
                        <button type="submit">
                          <i className="bx bx-search"></i>
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
              <div className="line" />
              {loading ? (
                <div className="admin-loader">
                  <Lottie
                    options={defaultOptionsLoading}
                    height={150}
                    width={150}
                  />
                </div>
              ) : (
                <div className="boxes-container">
                  {listPackages?.length > 0 ? (
                    listPackages.map((prod, index) => (
                    <div className="package-card" key={prod?._id || index}>
                      {/* IMAGE */}
                      <div className="package-card__image">
                        {!isImageLoaded && (
                          <div className="package-card__loader">
                            <Lottie
                              options={defaultloadImage}
                              height={90}
                              width={90}
                            />
                          </div>
                        )}

                        <img
                          src={`${api}/package/photo/${prod?._id}`}
                          alt="package"
                          onLoad={() => setIsImageLoaded(true)}
                        />
                      </div>

                      {/* ACTIONS */}
                      <div className="package-card__actions">
                        <button
                          className="icon-btn danger"
                          onClick={() => openDelete(prod?._id)}
                        >
                          <i className="bx bx-trash" />
                        </button>

                        <button
                          className="icon-btn"
                          onClick={() => openEditMode(prod)}
                        >
                          <i className="bx bx-edit" />
                        </button>
                      </div>

                      {/* INFO */}
                      <div className="package-card__info">
                        <div className="top-row">
                          <h3 className="name">{prod?.name}</h3>
                          <span className="price">{prod?.price} DT</span>
                        </div>

                        <div className="meta-row">
                          <span className="stock">
                            {prod?.quantity} in stock
                          </span>
                          <span className="sold">{prod?.sold}%</span>
                        </div>

                        <p className="desc">{prod?.description}</p>
                      </div>
                    </div>
                    ))
                  ) : (
                    <div className="boxes-empty">No packages found</div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      ) : (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        {step == "first" ? (
          <ModalPackage
            setStep={setStep}
            productsValues={productsValues}
            setProductsValues={setProductsValues}
            editMode={editMode}
            closeModal={closeModal}
            step={step}
          />
        ) : step == "second" ? (
          <ModalAddPackagePhoto
            setStep={setStep}
            step={step}
            closeModal={closeModal}
            setSelectedImage={setSelectedImage}
            selectedImage={selectedImage}
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            editMode={editMode}
            productsValues={productsValues}
          />
        ) : (
          <ModalAssociatedProds
            setStep={setStep}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            SubmitPackage={SubmitPackage}
            editMode={editMode}
            productsValues={productsValues}
            closeModal={closeModal}
            loadingSave={loadingSave}
          />
        )}
      </Modal>
      <Modal
        isOpen={isOpenDelete}
        onRequestClose={closeDeleteModal}
        style={customStylesDelete}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalViderBasket
          action={handleDelete}
          closeModal={closeDeleteModal}
          text={"Are you sure to delete this package ?"}
        />
      </Modal>
    </>
  );
}

export default Packages;
